export default __webpack_public_path__ + "static/asiapacific2020bronze-6d3137027eae2ef9b2589bd82d3e2d38.jpg";